export default __webpack_public_path__ + "static/media/LO12.10294545.mp3";